var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 45,
  viewBox: "0 0 60 45",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m20.976 25.728 5.293 3.913c1.307.888 6.537.888 7.844 0l5.23-3.908a4346 4346 0 0 0 8.794 5.923l.762.512 2.68 1.8.763.512c2.7 1.812 5.338 3.58 7.658 5.135v.376A4.997 4.997 0 0 1 55 45H5c-2.757 0-5-2.243-5-5.01v-.133zM0 11.663l17.118 11.443L0 34.74zm59.999.076v22.923l-16.83-11.556zM55 0c2.757 0 5 2.243 5 5.01l-.001 2.121-28.5 18.96c-1.251.85-1.306.887-2.452.112l-.163-.111L0 6.876V5.009A4.997 4.997 0 0 1 4.783.005L5 0Z"
})));
export default SvgChannelMail;